export const COUNTRY_DELETE_RESET = 'COUNTRY_DELETE_RESET'
export const COUNTRY_DELETE_SET_ERROR = 'COUNTRY_DELETE_SET_ERROR'
export const COUNTRY_DELETE_SET_DELETED = 'COUNTRY_DELETE_SET_DELETED'
export const COUNTRY_DELETE_TOGGLE_LOADING = 'COUNTRY_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/country/delete/mutation_types.js